import React from 'react';

/**
 * CTASlide - Slide 17: Dark background CTA with "Try Tasky" features and signup button.
 */
const CTASlide: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        height: '100%',
        background: '#1D1926',
        color: '#fff',
      }}
    >
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <p className="sl" style={{ color: 'rgba(255,255,255,0.3)', marginBottom: 'clamp(12px, 2vmin, 24px)' }}>
          Try Tasky
        </p>
        <h2 style={{ fontSize: 'clamp(24px, 5vw, 44px)', fontWeight: 700, lineHeight: 1.3, marginBottom: 'clamp(12px, 2vmin, 24px)', maxWidth: 900 }}>
          無料トライアルに登録して、<br />
          <span style={{ color: 'rgba(255,255,255,0.4)' }}>あなたのバナーを作ってみませんか？</span>
        </h2>
        <div style={{ width: 48, height: 2, background: 'rgba(255,255,255,0.2)', marginBottom: 'clamp(20px, 3vmin, 32px)' }} />

        {/* Features box */}
        <div
          style={{
            border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: 8,
            padding: 'clamp(16px, 2.4vmin, 32px)',
            maxWidth: 620,
            width: '100%',
            marginBottom: 'clamp(20px, 3vmin, 32px)',
            textAlign: 'left',
          }}
        >
          <p style={{ textAlign: 'center', fontSize: 16, fontWeight: 700, marginBottom: 20 }}>Taskyでできること</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {[
              {
                icon: (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                    <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                  </svg>
                ),
                title: 'URLを入れるだけで戦略設計',
                desc: 'サイト分析からUSP・ターゲット・訴求を自動で整理',
              },
              {
                icon: (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2">
                    <path d="M12 2L15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2z" />
                  </svg>
                ),
                title: 'AIがバナーを自動生成',
                desc: '訴求軸 x セグメント x パターンで大量のクリエイティブを生成',
              },
              {
                icon: (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                  </svg>
                ),
                title: '効果予測スコアで優先順位がわかる',
                desc: 'どのバナーから配信すべきかAIが判断',
              },
            ].map((item, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16,
                  borderLeft: '2px solid rgba(255,255,255,0.2)',
                  paddingLeft: 16,
                }}
              >
                {item.icon}
                <div>
                  <p style={{ fontSize: 15, fontWeight: 700 }}>{item.title}</p>
                  <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA buttons */}
        <div className="cta-buttons">
          <a
            href="/signup"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#3eb298',
              color: '#fff',
              fontSize: 'clamp(14px, 1.8vmin, 16px)',
              fontWeight: 600,
              padding: '14px 32px',
              borderRadius: 9999,
              textDecoration: 'none',
              minHeight: 48,
              transition: 'opacity 0.2s',
            }}
          >
            Taskyを無料で試してみる →
          </a>
          <a
            href="/pricing"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid rgba(255,255,255,0.25)',
              color: '#fff',
              fontSize: 14,
              fontWeight: 500,
              padding: '12px 24px',
              borderRadius: 9999,
              textDecoration: 'none',
              transition: 'background 0.2s',
            }}
          >
            料金を見る
          </a>
        </div>
      </div>
      <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.2)', paddingBottom: 8 }}>
        クレジットカード不要。メールアドレスだけで始められます。
      </p>
    </div>
  );
};

export default CTASlide;
